import lv from '../country/lv.svg'
import ru from '../country/ru.svg'
import gb from '../country/gb.svg'
import us from '../country/us.svg'
import de from '../country/de.svg'

export default {
  lv,
  ru,
  gb,
  de,
  us,
  en: gb
}



// WEBPACK FOOTER //
// ./src/assets/img/flags/language/index.js